import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import Tasks from '../containers/Tasks';
const MilestoneTasks = ({params}) => {
    return(
        <Tasks params={params} />
    )
}
export default withRouter(MilestoneTasks);